import React from 'react';
import { useTranslation } from "@/lib/i18n";
import { PenTool, Box } from 'lucide-react';

export default function StrokePanel({
  strokeColor,
  strokeWidth,
  isSingleSelected,
  onApplyStrokeColor,
  onApplyStrokeWidth,
  onGenerateOutlines,
  theme = 'dark',
}) {
  const { t } = useTranslation('editor');

  return (
    <div
      className={`border rounded-md p-2 flex flex-col gap-1.5 transition-all duration-300 ${
        theme === 'dark' ? 'bg-zinc-950/70 border-zinc-800' : 'bg-white border-slate-100 shadow-sm'
      } ${
        isSingleSelected ? 'opacity-100' : 'opacity-40 pointer-events-none'
      }`}
    >
      <div className="flex items-center justify-between">
        <span className={`text-[11px] font-semibold uppercase flex items-center gap-1 ${
          theme === 'dark' ? 'text-zinc-400' : 'text-slate-500'
        }`}>
          <PenTool className="w-3.5 h-3.5 text-amber-400" /> {t('colors.stroke_settings', { defaultValue: 'Stroke Settings' })}
        </span>
      </div>

      <div className="flex items-center gap-3">
        <div className="flex flex-col gap-1 flex-1">
          <span className={`text-[9px] uppercase ${theme === 'dark' ? 'text-zinc-500' : 'text-slate-400'}`}>
            {t('colors.stroke_width', { defaultValue: 'Width' })}
          </span>
          <div className="flex items-center gap-2">
            <input
              type="range"
              min="0"
              max="60"
              step="0.5"
              value={strokeWidth || 0}
              onChange={(e) => onApplyStrokeWidth(parseFloat(e.target.value))}
              className="flex-1 h-1.5 bg-zinc-700 rounded-lg appearance-none cursor-pointer accent-indigo-500 min-w-[60px]"
            />
            <span className={`text-[10px] min-w-[25px] font-mono ${theme === 'dark' ? 'text-zinc-300' : 'text-slate-600'}`}>
              {strokeWidth || 0}
            </span>
            
            <button
              onClick={onGenerateOutlines}
              disabled={!isSingleSelected || (strokeWidth || 0) <= 0}
              title={t('colors.generate_outlines', { defaultValue: 'Generate outlines' })}
              className={`p-1 rounded transition-colors ${
                theme === 'dark' 
                  ? 'hover:bg-zinc-800 text-zinc-400 hover:text-indigo-400' 
                  : 'hover:bg-slate-100 text-slate-500 hover:text-indigo-500'
              } disabled:opacity-30 disabled:pointer-events-none`}
            >
              <Box className="w-4 h-4" />
            </button>
          </div>
        </div>

        <div className="flex flex-col gap-1">
           <span className={`text-[9px] uppercase ${theme === 'dark' ? 'text-zinc-500' : 'text-slate-400'}`}>
            {t('colors.color', { defaultValue: 'Color' })}
          </span>
          <div
            className={`relative w-6 h-6 rounded border overflow-hidden cursor-pointer hover:scale-105 transition-transform ${
              theme === 'dark' ? 'border-zinc-700' : 'border-slate-200'
            }`}
          >
            <input
              type="color"
              value={strokeColor || '#000000'}
              onChange={(e) => onApplyStrokeColor(e.target.value)}
              disabled={!isSingleSelected}
              className="absolute -top-2 -left-2 w-10 h-10 cursor-pointer border-0 p-0"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
